import Vuex from 'vuex'
import auth from './modules/auth'
import urls from './modules/urls'
import selectors from './modules/selectors'
import choices from './modules/choices'
import personal_account from "@/store/modules/personal_account/index"

export default new Vuex.Store({
  modules: {
    auth,
    urls,
    selectors,
    choices,
    personal_account
  },
  state: {},
  getters: {},
  mutations: {}
})
